import React from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from "react-redux";

import {
  setWizardPopupDisabledScenes,
  setWizardPopupItem,
  setWizardPopupOpened,
  updateWizardList
} from "../wizardActions";
import {defaultWizardItem} from "../WizardItem/wizardItemInterface";
import {WIZARD_POPUP_TYPES} from "../wizardReducer";
import WizardPopupContext, {useCustomContext} from "./WizardPopupContext";
import {getWizardGroupLogic, setWizardItemWizardGroupsRooms} from "../wizardFunctions";
import {saveWizardFeaturesToolSettings} from "../wizardAsyncActions";

const needToUpdateFields = (wizardPopupType) => {
  switch (wizardPopupType) {
    case WIZARD_POPUP_TYPES.editGroup: {
      return ["title", "description", "productCartTitle", "productCartDescription", "uploadedImageUrl", "customImageUrl",
        "notRequired", "multipleAddToCart", "isCenterIslandGroup", "hideInCartAndReceipt", "wizardGroupIcon", "leadStep",
        "separateSqftLabel", "headerTitle", "headerSubTitle", "viewType", "visibleInVisualizers", "skipProductInfo",
        "clickOnLogic", "hidePriceNoCart", "skipLockDontApply", "dontMatchFeaturesBySku", "matchAllDisabled"]
    }
    case WIZARD_POPUP_TYPES.featuresExclusion: {
      return ["featuresExcluded", "featuresIncluded", "useIncluded"]
    }
    case WIZARD_POPUP_TYPES.filtersExclusion: {
      return ["filtersExcluded"]
    }
    case WIZARD_POPUP_TYPES.inputsSetup: {
      return ["inputFields"]
    }
    default:
      return []
  }
}

const doNotUpdateSiblingProperties = ["useIncluded", "featuresExcluded", "featuresIncluded", "filtersExcluded",
  "productCartTitle", "productCartDescription", "uploadedImageUrl", "customImageUrl", "visibleInVisualizers",
  "clickOnLogic"];

const WizardPopupSaveButton = (props) => {

  const {setWizardPopupOpened, updateWizardList, wizardPopupItem, setWizardPopupItem, wizardPopupType, wizardPopupGroup,
    wizardPopupDisabledScenes, setWizardPopupDisabledScenes, wizardVisualizer, saveWizardFeaturesToolSettings, intl,
    wizardPopupEditToggles} = props;

  const {wizardPopupState} = useCustomContext(WizardPopupContext);

  const saveButtonClick = async () => {
    switch (wizardPopupType) {
      case WIZARD_POPUP_TYPES.editGroup:
      case WIZARD_POPUP_TYPES.featuresExclusion:
      case WIZARD_POPUP_TYPES.inputsSetup:
      case WIZARD_POPUP_TYPES.filtersExclusion: {
        if (!wizardPopupGroup) {
          break;
        }
        console.log("wizardPopupState to save", wizardPopupState);
        const {siblingGroups} = getWizardGroupLogic(wizardPopupGroup, wizardPopupItem);
        wizardPopupItem.wizardGroups = wizardPopupItem.wizardGroups.map(wizGroup => {
          const isSibling = siblingGroups.some(sibGroup => sibGroup.id === wizGroup.id);
          if (wizGroup.id === wizardPopupGroup.id || isSibling) {
            needToUpdateFields(wizardPopupType).forEach(property => {
              if ((wizGroup.id !== wizardPopupGroup.id) && isSibling && doNotUpdateSiblingProperties.includes(property)) {
                return
              }
              wizGroup[property] = Array.isArray(wizardPopupState[property]) ? [...wizardPopupState[property]] : wizardPopupState[property]
            });
            if (wizardPopupType === WIZARD_POPUP_TYPES.featuresExclusion && wizGroup.useIncluded) {
              wizGroup.featuresExcluded = [];
              // console.log("removing excluded from save", wizGroup);
            }
          }
          return wizGroup
        });
        if (wizardVisualizer === "all") {
          if (wizardPopupType === WIZARD_POPUP_TYPES.editGroup) {
            if (wizardPopupGroup.groupName === "Room") {
              setWizardItemWizardGroupsRooms(wizardPopupItem, wizardPopupGroup)
            }
          } else if (wizardPopupType === WIZARD_POPUP_TYPES.featuresExclusion) {
            await saveWizardFeaturesToolSettings(wizardPopupState, intl);
          }
        }
        updateWizardList(wizardPopupItem);
        break;
      }
      case WIZARD_POPUP_TYPES.sceneSelection: {
        wizardPopupItem.disabledScenes = [...wizardPopupDisabledScenes];
        updateWizardList(wizardPopupItem);
        setWizardPopupDisabledScenes([]); // clear current scenes
        break;
      }
      case WIZARD_POPUP_TYPES.start: {
        wizardPopupItem.startTitle = wizardPopupState.title;
        wizardPopupItem.startDescription = wizardPopupState.description;
        wizardPopupItem.skipStartStep = wizardPopupState.skipStartStep;
        updateWizardList(wizardPopupItem);
        break;
      }
      case WIZARD_POPUP_TYPES.editItemToggles: {
        updateWizardList({...wizardPopupItem, ...wizardPopupEditToggles});
        break;
      }
    }

    setWizardPopupOpened(false);
    setWizardPopupItem(defaultWizardItem); // clear existing values
  };

  const disabled = !wizardPopupItem;

  return (
    <button className={"ui-button5 ui-button5--wide text-uppercase ui-button5--green" + (disabled ? " ui-button--disabled" : "")}
            onClick={saveButtonClick}
            disabled={disabled}>
      <FormattedMessage id="messageBox.buttons.save"/>
    </button>
  )
};

const mapStateToProps = (store) => {
  const {wizardPopupType, wizardPopupItem, wizardPopupGroup, wizardPopupDisabledScenes, wizardVisualizer,
    wizardPopupEditToggles} = store.wizardState;
  return {
    wizardPopupItem,
    wizardPopupType,
    wizardPopupDisabledScenes,
    wizardPopupGroup,
    wizardVisualizer,
    wizardPopupEditToggles,
  };
};

const mapDispatchToProps = {
  setWizardPopupOpened,
  updateWizardList,
  setWizardPopupItem,
  setWizardPopupDisabledScenes,
  saveWizardFeaturesToolSettings,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(WizardPopupSaveButton)
)
